import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import config from "../../config";
import {getIdToken} from "../../auth/pwaAuth";

const api = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: config.REACT_APP_API_URL,
        prepareHeaders: async (headers) => {
            // Идентичность залогиненного игрока бэкенд берёт только из Firebase ID token.
            const token = await getIdToken();
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers
        }
    }),
    endpoints: () => ({})
})

export default api
